module.exports = __webpack_public_path__ + "static/media/featured-stone.a0b2c61b.svg";